<button mat-icon-button>
    <mat-icon class="icon {{ icon.class }}">
        {{ icon.materialIcon }}
    </mat-icon>
</button>
